import { useMediaQuery } from "../../hooks/useMediaQuery";
import {
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  MOBILE_QUERY,
} from "../Dialog";
import type { IModalProps } from "./types";

const ModalRoot = ({ drawerOnMobile = true, ...props }: IModalProps) => {
  const isMobile = useMediaQuery(MOBILE_QUERY);
  // Same tree either way: only the placement class changes, so nothing remounts.
  const placement = drawerOnMobile && isMobile ? "bottom" : "center";

  return <DialogRoot {...props} placement={placement} />;
};

export const Modal = Object.assign(ModalRoot, {
  Header: DialogHeader,
  Body: DialogBody,
  Footer: DialogFooter,
});
